import { QueryHookOptions, useQuery } from '@apollo/client';
import gql from 'graphql-tag';

const query = gql`
  query GetJourney($userId: String!, $gameType: String!) {
    journeyByUserAndGametype(userId: $userId, gameType: $gameType) {
      _id
      userId
      gameType
      currentStage
      history {
        stageId
        type
        completedAt
        details
      }
    }
  }
`;

export type TJourneyHistory = {
  stageId: string;
  type: string;
  completedAt: string;
  details?: string;
};

export type TJourney = {
  id: string;
  userId: string;
  gameType: string;
  currentStage: string;
  history: TJourneyHistory[];
};

export type TQueryJourney = {
  journeyByUserAndGametype: TJourney;
};

export function useJourneyQuery(
  options?: QueryHookOptions<TQueryJourney, { userId: string; gameType: string; }>,
) {
  return useQuery<TQueryJourney, { userId: string; gameType: string; }>(
    query,
    options,
  );
}
